import React, { useState } from 'react';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  Box, Card, CardContent, TextField, Button, Typography, Alert, Grid,
} from '@mui/material';
import BookIcon from '@mui/icons-material/Book';
import { registerUserApi } from '../../api/auth';
import { loginSuccess } from '../../store/authSlice';

export default function Register() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [form, setForm] = useState({
    name: '', email: '', mobile_number: '', password: '', confirm_password: '',
  });
  const [errors, setErrors] = useState({});
  const [nonFieldError, setNonFieldError] = useState('');
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});
    setNonFieldError('');

    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) => { if (v) fd.append(k, v); });

    try {
      const res = await registerUserApi(fd);
      dispatch(loginSuccess(res.data));
      navigate('/books');
    } catch (err) {
      const data = err.response?.data || {};
      if (data.non_field_errors) {
        setNonFieldError(data.non_field_errors[0]);
      } else if (typeof data === 'string') {
        setNonFieldError(data);
      } else {
        setErrors(data);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default', p: 2 }}>
      <Card sx={{ maxWidth: 560, width: '100%' }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <BookIcon sx={{ fontSize: 40, color: 'primary.main' }} />
            <Typography variant="h5" sx={{ mt: 1 }}>Create Account</Typography>
            <Typography variant="body2" color="text.secondary">Register as an end user</Typography>
          </Box>

          {nonFieldError && <Alert severity="error" sx={{ mb: 2 }}>{nonFieldError}</Alert>}

          <Box component="form" onSubmit={handleSubmit} noValidate>
            <Typography variant="subtitle2" sx={{ mb: 1.5, color: 'primary.main', fontWeight: 700 }}>
              Personal Information
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Full Name" value={form.name} onChange={set('name')}
                  required error={!!errors.name} helperText={errors.name?.[0]} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Email ID" type="email" value={form.email}
                  onChange={set('email')} required error={!!errors.email} helperText={errors.email?.[0]} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Mobile Number" value={form.mobile_number}
                  onChange={set('mobile_number')} error={!!errors.mobile_number}
                  helperText={errors.mobile_number?.[0]} inputProps={{ maxLength: 15 }} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Password" type="password" value={form.password}
                  onChange={set('password')} required error={!!errors.password}
                  helperText={errors.password?.[0]} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Confirm Password" type="password"
                  value={form.confirm_password} onChange={set('confirm_password')} required
                  error={!!errors.confirm_password} helperText={errors.confirm_password?.[0]} />
              </Grid>
            </Grid>

            <Button type="submit" fullWidth variant="contained" size="large" disabled={loading} sx={{ mt: 3 }}>
              {loading ? 'Registering...' : 'Register'}
            </Button>
          </Box>

          <Box sx={{ textAlign: 'center', mt: 2 }}>
            <Typography variant="body2">
              Already have an account?{' '}
              <RouterLink to="/login" style={{ color: '#1565c0', fontWeight: 600 }}>Sign in</RouterLink>
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
